module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.localizedMainNav) ? _c('nav', {
    staticClass: "c-main-nav",
    class: {
      visible: _vm.mobileNavVisible
    }
  }, [_c('div', {
    staticClass: "c-main-nav__bg",
    style: ({
      transform: 'skew(0, ' + _vm.skewRadius + 'deg)'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "c-main-nav__burger",
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [_c('span', [_vm._v("Navigation")])]), _vm._v(" "), _c('router-link', {
    staticClass: "c-main-nav__logo",
    attrs: {
      "to": _vm.localizedLogoLink
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/bandara-logo.svg",
      "alt": "Bandara"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "c-main-nav__list"
  }, _vm._l((_vm.localizedMainNav.items), function(item) {
    return _c('router-link', {
      key: item.link,
      staticClass: "c-main-nav__list-item",
      attrs: {
        "tag": "li",
        "to": item.link
      }
    }, [_c('a', {
      staticClass: "c-main-nav__link"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t")])])
  })), _vm._v(" "), _c('ul', {
    staticClass: "c-main-nav__lang"
  }, [_c('li', {
    class: this.settings.currentLang === 'de-ch' ? 'c-main-nav__lang-item is-active' : 'c-main-nav__lang-item'
  }, [_c('router-link', {
    staticClass: "c-main-nav__lang-link",
    attrs: {
      "to": this.settings.altLangLinks['de-ch']
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClick('de-ch')
      }
    }
  }, [_vm._v("\n\t\t\t\t\tDe\n\t\t\t\t")])], 1), _vm._v(" "), _c('li', {
    class: this.settings.currentLang === 'en-us' ? 'c-main-nav__lang-item is-active' : 'c-main-nav__lang-item'
  }, [_c('router-link', {
    staticClass: "c-main-nav__lang-link",
    attrs: {
      "to": this.settings.altLangLinks['en-us']
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClick('en-us')
      }
    }
  }, [_vm._v("\n\t\t\t\t\tEn\n\t\t\t\t")])], 1)])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-600eb98a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainNav.vue
// module id = 271
// module chunks = 0